import type { AxiosResponse } from 'axios';
import axios from 'axios';

import { useTokenStore } from '~/store/modules/token/useTokenStore';

const apiSessionRaw = axios.create({
  baseURL: process.env.REACT_APP_API_SESSION_URL,
});

export async function logoutSession(
  refreshToken: string,
  authorization: string = useTokenStore.getAuthorizationHeader(),
): Promise<AxiosResponse<void>> {
  return apiSessionRaw.post(
    '/api/sessions/logout',
    { refreshToken },
    { headers: authorization ? { Authorization: authorization } : undefined },
  );
}
